import React from "react";
import I18nServicePage from "@/components/I18nServicePage";
import { IMG } from "@/lib/config";

export default function CooConseil() {
  return <I18nServicePage i18nKey="coo" image={IMG.coo} testIdPrefix="coo" accentClass="text-accent-pink" />;
}
